<template>
  <CSidebar class="pretest-sidebar" position="fixed" :visible="true">
    <div>
      <div class="brand">
        <CSidebarBrand
          style="cursor: pointer"
          @click="$router.push('/analysis-report/report-enterprise-list')"
        >
          <img src="@/assets/images/logo-black.svg" />
        </CSidebarBrand>
      </div>
      <div class="content-wrapper" style="max-height: calc(100vh - 250px); overflow-y:scroll;">
        <router-link
          :to="link.path"
          class="link"
          v-for="link in isLinkShow"
          :key="link.title"
          v-show="isButtonShow(link.key)"
          :class="$route.path === link.path ? 'active' : ''"
        >
          <img
            class="me-3"
            style="width: 20px"
            :src="
              $route.path === link.path
                ? require(`@/assets/icons/${link.img}-active.svg`)
                : require(`@/assets/icons/${link.img}.svg`)
            "
            alt=""
          />
          {{ link.title }}
        </router-link>
        <div
          v-if="isButtonShow('role/search') || isButtonShow('sign/backend-search')"
          class="link"
          :class="
            $route.path === '/user-management/user-group-list' ||
            $route.path === '/user-management/user-manager-list'
              ? 'active'
              : ''
          "
        >
          <img
            class="me-3"
            :src="
              $route.path === '/user-management/user-group-list' ||
              $route.path === '/user-management/user-manager-list'
                ? require(`@/assets/icons/permission-active.svg`)
                : require(`@/assets/icons/permission.svg`)
            "
          />
          權限管理
        </div>
        <div class="children-link-wrapper">
          <router-link
            :to="link.path"
            class="children-link"
            v-for="link in permission"
            :key="link.title"
            v-show="isButtonShow(link.key)"
            :class="$route.path === link.path ? 'active' : ''"
          >
            {{ link.title }}
          </router-link>
        </div>
      </div>
    </div>
    <div class="user">
      <div class="url-wrapper">
        <a :href="`https://${client}`" target="_blank">用戶前台</a>
      </div>
      <span class="fw-bold">{{ username }}</span>
      <button
        @click="logout"
        class="btn border-0 p-0 d-flex align-items-center"
      >
        <img class="me-2" src="@/assets/icons/logout.svg" alt="" />
        <span>登出</span>
      </button>
    </div>
  </CSidebar>
  <MsgBox
    :show="showMsgBox"
    :errorCode="errorCode"
    :errorMsg="errorMsg"
    @close="showMsgBox = false"
  />
</template>
<script>
import { ref } from '@vue/reactivity'
import { onMounted, computed } from '@vue/runtime-core'
import useInfo from '@/composables/useInfo'
import MsgBox from '@/components/MsgBox.vue'
import router from '@/router'
import { useStore } from 'vuex'

export default {
  components: {
    MsgBox,
  },
  setup() {
    const { getUserInfo, signOut } = useInfo()
    const showMsgBox = ref(false)
    const errorMsg = ref('')
    const errorCode = ref('')
    const username = ref('')
    const store = useStore()
    const isPermissionActive = ref(false)
    const client = window.location.host;
    const permission = ref([
      {
        title: '管理者群組',
        key: 'role/search',
        path: '/user-management/user-group-list',
      },
      {
        title: '管理者列表',
        key: 'sign/backend-search',
        path: '/user-management/user-manager-list',
      },
    ])
    const links = ref([
      {
        title: '問卷列表',
        img: 'analysis',
        key: 'questionnaire/info',
        path: '/analysis-questionnaire',
      },
      {
        title: '用戶填答結果',
        img: 'analysis-report',
        key: 'questionnaire/fill-in-list',
        path: '/analysis-report/report-enterprise-list',
      },
      {
        title: '用戶管理',
        img: 'user-management',
        key: 'sign/list',
        path: '/user-management/user-enterprise-list',
      },
      {
        title: 'JYG ESG 企業健檢',
        img: 'reply',
        key: 'questionnaire/form-list',
        path: '/user-management/user-reply',
      },
      {
        title: '來信列表',
        img: 'email',
        key: 'user/contact-search',
        path: '/user-management/message-list',
      },
      {
        title: 'E-Mail列表',
        img: 'arroba',
        key: 'setting/contact-email-search',
        path: '/user-management/email-list',
      },
    ])
    onMounted(async () => {
      const res = await getUserInfo()
      if (res.error) {
        showMsgBox.value = true
        errorMsg.value = res.msg
        errorCode.value = res.error
      } else {
        username.value = res.ret.info.username
      }
    })
    const isButtonShow = (key)=>{
      if(store.state.userInfo.auth_data === true){
        return true
      }else{
        return Object.values(store.state.userInfo.auth_data).includes(key)
      }
    }
    const isLinkShow = computed(()=>{
      return links.value.filter(e=>{
        let isShow = false 
        if(store.state.userInfo.auth_data === true){
          isShow = true
        }else{
          isShow = store.state.userInfo.auth_data ? Object.values(store.state.userInfo.auth_data).includes(e.key) : true
        }
        return isShow
      })
    })
    const logout = async () => {
      await signOut()
      router.push('/sign')
    }
    return {
      links,
      showMsgBox,
      errorMsg,
      errorCode,
      username,
      isPermissionActive,
      permission,
      logout,
      isLinkShow,
      isButtonShow,
      client
    }
  },
}
</script>
<style lang="scss" scoped>
:global(.pretest-sidebar) {
  --cui-sidebar-brand-bg: none;
  --cui-sidebar-color: #4d4d4d;
  border-radius: 0 20px 20px 0;
  border: 1px solid #eff0f6;
  background: #ffffff;
  filter: drop-shadow(0px 5px 20px rgba(0, 0, 0, 0.05));
  display: flex;
  justify-content: space-between;
}
.brand {
  padding: 24px 0;
  img {
    width: 120px;
  }
}
.content-wrapper {
  padding: 0 25px;
}
.link {
  display: block;
  margin-bottom: 16px;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: -0.154px;
  color: #4d4d4d;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-decoration: none;
  height: 48px;
  display: flex;
  align-items: center;
  padding: 0 19px;
  border-radius: 10px;
  cursor: pointer;
}
.user {
  height: 173px;
  border-top: 1px solid #e5e5e5;
  margin: 0 10px;
  padding: 30px 28px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  cursor: default;
}
.active {
  background: #f3f8fb;
  color: #177baf;
}
.children-link-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.children-link {
  display: block;
  width: 90%;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: -0.154px;
  color: #6c6c6c;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-decoration: none;
  display: flex;
  align-items: center;
  padding: 15px 20px 15px 20px;
  border-left: 1px solid rgba(0, 0, 0, 0.2);
  cursor: pointer;
}
.url-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  a {
    font-weight: 500;
    text-decoration: none;
    color: #177baf;
    &:hover {
      color: #4a9fcd;
    }
  }
}
</style>
